/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { CompanyTree } from '@veeam-vspc/models/web-controllers';

import type { OrganizationsFlatMap } from '../interfaces';

const flatMap: OrganizationsFlatMap = new Map();

export const flatOrganizationsTree = (node: CompanyTree): OrganizationsFlatMap => {
    const preparedNode = {
        ...node,
        children: undefined,
        hasChildren: node.children?.length > 0,
    };

    if (node.children) {
        node.children.forEach((el) => {
            flatOrganizationsTree(el);
        });
    }

    flatMap.set(
        node.id ?? -1,
        preparedNode,
    );

    return flatMap;
};
